// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHouseholdMissingDocumentsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type GetHouseholdMissingDocumentsQuery = { __typename?: 'Query', householdMissingDocuments: Array<(
    { __typename?: 'HouseholdMissingDocument' }
    & HouseholdMissingDocumentFragment
  )>, clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: (
        { __typename?: 'ClientProfile' }
        & ClientProfile_MissingDocumentFragment
      ) | null } | null> | null } };

export type HouseholdMissingDocumentFragment = { __typename?: 'HouseholdMissingDocument', documentType: Types.MissingDocumentOverrideDocumentType, isOverridden?: boolean | null, clientProfile?: (
    { __typename?: 'ClientProfile' }
    & ClientProfile_MissingDocumentFragment
  ) | null };

export type HouseholdMissingDocumentOverrideFragment = { __typename?: 'MissingDocumentOverride', id: string, documentType: Types.MissingDocumentOverrideDocumentType, clientProfile?: (
    { __typename?: 'ClientProfile' }
    & ClientProfile_MissingDocumentFragment
  ) | null };

export type ClientProfile_MissingDocumentFragment = { __typename?: 'ClientProfile', id: string, displayName: string, isPrimary: boolean, dateOfBirth?: Time | null };

export type RestoreDismissedMissingDocumentsMutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;


export type RestoreDismissedMissingDocumentsMutation = { __typename?: 'Mutation', restoreDismissedMissingDocuments: number };

export type CreateMissingDocumentOverrideMutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  documentType: Types.MissingDocumentOverrideDocumentType;
  clientProfileID?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type CreateMissingDocumentOverrideMutation = { __typename?: 'Mutation', createMissingDocumentOverride: (
    { __typename?: 'MissingDocumentOverride' }
    & HouseholdMissingDocumentOverrideFragment
  ) };

export const Operations = {
  Query: {
    GetHouseholdMissingDocuments: 'GetHouseholdMissingDocuments' as const
  },
  Mutation: {
    RestoreDismissedMissingDocuments: 'RestoreDismissedMissingDocuments' as const,
    CreateMissingDocumentOverride: 'CreateMissingDocumentOverride' as const
  },
  Fragment: {
    HouseholdMissingDocument: 'HouseholdMissingDocument' as const,
    HouseholdMissingDocumentOverride: 'HouseholdMissingDocumentOverride' as const,
    ClientProfile_MissingDocument: 'ClientProfile_MissingDocument' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientProfile_MissingDocumentFragmentDoc = gql`
    fragment ClientProfile_MissingDocument on ClientProfile {
  id
  displayName
  isPrimary
  dateOfBirth
}
    `;
export const HouseholdMissingDocumentFragmentDoc = gql`
    fragment HouseholdMissingDocument on HouseholdMissingDocument {
  documentType
  clientProfile {
    ...ClientProfile_MissingDocument
  }
  isOverridden
}
    ${ClientProfile_MissingDocumentFragmentDoc}`;
export const HouseholdMissingDocumentOverrideFragmentDoc = gql`
    fragment HouseholdMissingDocumentOverride on MissingDocumentOverride {
  id
  documentType
  clientProfile {
    ...ClientProfile_MissingDocument
  }
}
    ${ClientProfile_MissingDocumentFragmentDoc}`;
export const GetHouseholdMissingDocumentsDocument = gql`
    query GetHouseholdMissingDocuments($householdID: ID!) {
  householdMissingDocuments(householdID: $householdID) {
    ...HouseholdMissingDocument
  }
  clientProfiles(
    where: {and: [{hasHouseholdWith: {id: $householdID}}, {or: [{isPrimary: true}, {hasRelationshipsWith: {type: CHILD}}]}]}
  ) {
    edges {
      node {
        ...ClientProfile_MissingDocument
      }
    }
  }
}
    ${HouseholdMissingDocumentFragmentDoc}
${ClientProfile_MissingDocumentFragmentDoc}`;

/**
 * __useGetHouseholdMissingDocumentsQuery__
 *
 * To run a query within a React component, call `useGetHouseholdMissingDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdMissingDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdMissingDocumentsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useGetHouseholdMissingDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>(GetHouseholdMissingDocumentsDocument, withFetchPolicyContext(options));
      }
export function useGetHouseholdMissingDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>(GetHouseholdMissingDocumentsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHouseholdMissingDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>(GetHouseholdMissingDocumentsDocument, withFetchPolicyContext(options));
        }
export type GetHouseholdMissingDocumentsQueryHookResult = ReturnType<typeof useGetHouseholdMissingDocumentsQuery>;
export type GetHouseholdMissingDocumentsLazyQueryHookResult = ReturnType<typeof useGetHouseholdMissingDocumentsLazyQuery>;
export type GetHouseholdMissingDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdMissingDocumentsSuspenseQuery>;
export type GetHouseholdMissingDocumentsQueryResult = Apollo.QueryResult<GetHouseholdMissingDocumentsQuery, GetHouseholdMissingDocumentsQueryVariables>;
export const RestoreDismissedMissingDocumentsDocument = gql`
    mutation RestoreDismissedMissingDocuments($householdID: ID!) {
  restoreDismissedMissingDocuments(householdID: $householdID)
}
    `;
export type RestoreDismissedMissingDocumentsMutationFn = Apollo.MutationFunction<RestoreDismissedMissingDocumentsMutation, RestoreDismissedMissingDocumentsMutationVariables>;

/**
 * __useRestoreDismissedMissingDocumentsMutation__
 *
 * To run a mutation, you first call `useRestoreDismissedMissingDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDismissedMissingDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDismissedMissingDocumentsMutation, { data, loading, error }] = useRestoreDismissedMissingDocumentsMutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useRestoreDismissedMissingDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDismissedMissingDocumentsMutation, RestoreDismissedMissingDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDismissedMissingDocumentsMutation, RestoreDismissedMissingDocumentsMutationVariables>(RestoreDismissedMissingDocumentsDocument, options);
      }
export type RestoreDismissedMissingDocumentsMutationHookResult = ReturnType<typeof useRestoreDismissedMissingDocumentsMutation>;
export type RestoreDismissedMissingDocumentsMutationResult = Apollo.MutationResult<RestoreDismissedMissingDocumentsMutation>;
export type RestoreDismissedMissingDocumentsMutationOptions = Apollo.BaseMutationOptions<RestoreDismissedMissingDocumentsMutation, RestoreDismissedMissingDocumentsMutationVariables>;
export const CreateMissingDocumentOverrideDocument = gql`
    mutation CreateMissingDocumentOverride($householdID: ID!, $documentType: MissingDocumentOverrideDocumentType!, $clientProfileID: ID) {
  createMissingDocumentOverride(
    input: {householdID: $householdID, documentType: $documentType, clientProfileID: $clientProfileID}
  ) {
    ...HouseholdMissingDocumentOverride
  }
}
    ${HouseholdMissingDocumentOverrideFragmentDoc}`;
export type CreateMissingDocumentOverrideMutationFn = Apollo.MutationFunction<CreateMissingDocumentOverrideMutation, CreateMissingDocumentOverrideMutationVariables>;

/**
 * __useCreateMissingDocumentOverrideMutation__
 *
 * To run a mutation, you first call `useCreateMissingDocumentOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMissingDocumentOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMissingDocumentOverrideMutation, { data, loading, error }] = useCreateMissingDocumentOverrideMutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      documentType: // value for 'documentType'
 *      clientProfileID: // value for 'clientProfileID'
 *   },
 * });
 */
export function useCreateMissingDocumentOverrideMutation(baseOptions?: Apollo.MutationHookOptions<CreateMissingDocumentOverrideMutation, CreateMissingDocumentOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMissingDocumentOverrideMutation, CreateMissingDocumentOverrideMutationVariables>(CreateMissingDocumentOverrideDocument, options);
      }
export type CreateMissingDocumentOverrideMutationHookResult = ReturnType<typeof useCreateMissingDocumentOverrideMutation>;
export type CreateMissingDocumentOverrideMutationResult = Apollo.MutationResult<CreateMissingDocumentOverrideMutation>;
export type CreateMissingDocumentOverrideMutationOptions = Apollo.BaseMutationOptions<CreateMissingDocumentOverrideMutation, CreateMissingDocumentOverrideMutationVariables>;